<template>
  <div class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">Generate New Cheques </h1>
              <button
                  @click="onClickClose"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>

        <hr class="mt-0 mb-0">

        <div class="pb-2">
          <div class="row mx-2">
            <div class="col-12">
              <label class="form-label">Cheque # From <span class="required">*</span></label>
              <input type="number" v-model="formData.from" class="form-control" placeholder="Enter From Number">
            </div>

            <div class="col-12">
                <label class="form-label">Cheque # To <span class="required">*</span></label>
                <input type="number" v-model="formData.to" class="form-control" placeholder="Enter To Number">
            </div>

            <div class="col-12 text-center mb-2 mt-2">
              <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Generate
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loader"/>

  </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {inject, ref} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleAccounting from '@/services/modules/accounting'

const formData = ref({
  from:'',
  to:'',
})

const props = defineProps({
  accountHeadId: null
})

const emit = defineEmits(['close', 'getData']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const isEdit = ref(false);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const { createChequeRegister } = handleAccounting();

const submit = async() => {
  const query = getQuery();
  loading.value = true;
  await storeData(query)
}

const storeData = async (query) => {
  let chequeData = {};
  chequeData.from = formData.value.from;
  chequeData.to = formData.value.to;
  chequeData.account_head_id = props.accountHeadId;

  await createChequeRegister(chequeData, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit('getData')
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickClose = () => {
  emit('close')
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

</script>
